import React from "react";

export default function Info({ sectionTitle, data }) {
  return (
    <div>
      <p className="fw-bold text-primary mb-4">{sectionTitle}</p>
      <div className="d-flex flex-column gap-3">
        {data.map((item) => {
          return (
            <div
              key={item.title}
              style={{ fontSize: ".9rem" }}
              className="gap-2 d-flex align-items-center"
            >
              <p className="m-0">{item.title}: </p>
              <p className="m-0 fw-semibold">{item.value}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
